import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	maxOneFile: {
		id: 'attachments.errors.maxOneFile',
		defaultMessage: 'Нельзя прикрепить больше одного файла',
	},
	maxTwoFiles: {
		id: 'attachments.errors.maxTwoFiles',
		defaultMessage: 'Нельзя прикрепить больше двух файлов',
	},
	fileExtensionNotAllowed: {
		id: 'attachments.errors.fileExtensionNotAllowed',
		defaultMessage: 'Недопустимый формат файла. Разрешенные форматы: {allowedExtensions}',
	},
	maxFileSizeLimit: {
		id: 'attachments.errors.maxFileSizeLimit',
		defaultMessage: 'Размер файла не может превышать {maxFileSize} МБ',
	},
});
